var currencyCalculatorTemplate = require('templates/currencyCalculator.hbs');
var currencyCalculatorTemplateERS = require('templates/currencyCalculatorErs.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({
  type: 'currencyCalculator',
  template: {
    'currencyCalculator': currencyCalculatorTemplate,
    'currencyCalculatorErs': currencyCalculatorTemplateERS
  },
  subscribe: {
    'CURRENCY_CONVERTER_SECTION': 'showCurrencyCalculator',
    'HIDE-ALL-CALCULATOR-TABS': 'hideCalculatorTabContainer',
    'CURRENCY_CALCULATOR_ASSOCIATE_REFRESH': 'refresh'
  },
  events: {
    'click .clear-button': 'handleClearForm',
    'submit #currencyCalculatorForm': 'handleFormSubmit'
  },
  bindEvents: function ($) {
    this.$ = $;
    $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    $('.tile-currency-calculator-associate').on('change', '.selectric-js-guest-country', this.handleGuestCountryChange.bind(this));
  },

  handleGuestCountryChange: function _handleGuestCountryChange (event) {

    var $parent = this.$el.find('.js-guest-country-currency-section');
    var currencyMap = $parent.find('.js-currency-container').data('currencyMap');
    var target = $parent.find('.js-guest-currency');
    var selectedValue = this.$el.find('select.js-guest-country').val();
    var selectedCountryCurrency = currencyMap[selectedValue];
			 var valueToSend = '';
    if(selectedCountryCurrency) {
      valueToSend = selectedCountryCurrency.split('(')[1].slice(0,-1);
      target.text(selectedCountryCurrency);
    } else {
      target.text('');
    }
    
    $parent.find('.js-currency-name').val(valueToSend);
  },

  handleClearForm: function(event) {
    this.$el.find('#amount').val('');
    this.$el.find('#desiredCurrency').val('');
    window.$('#desiredCurrency').selectric('destroy').selectric('init');
  },

  handleFormSubmit: function(event) {
    event.preventDefault();
    var data = this.serializeFormData(this.$el.find('form')) || {};
    data.isSubmitFlow = true;
    this.refresh(data, this.refreshSuccessCallBack.bind(this));
  },

  refreshSuccessCallBack: function _refreshSuccessCallBack() {
    this.$el.removeClass('is-hidden');
  },

/**
 * Sample callbacks for message subscriptions and events
*/

  showCurrencyCalculator: function () {
    var _self = this;
    _self.pubsub.publish('HIDE-ALL-CALCULATOR-TABS');
    _self.pubsub.publish('SHOW_HOTEL_DETAIL_SEARCH');
    setTimeout(function () {
      _self.$el.removeClass('is-hidden');
      _self.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    }, 200);
  },

  hideCalculatorTabContainer: function () {
    this.pubsub.publish('HIDE_HOTEL_DETAIL_SEARCH');
    this.$el.addClass('is-hidden');
  }

});